import React, { useEffect, useRef } from "react";
import { Text, View, Dimensions, Animated } from "react-native";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "../../../../../Utils/responsive";
import { withRouter } from "react-router-dom";
import {
  buttonText,
  LOSSINTROBODY,
  lossLabels,
} from "../../../../../Utils/static-strings";
import ContinueButton from "../../../../../Components/ContinueButton";
import clockIcon from "../../../../../assets/images/clock-regular-full.svg";
const deviceWidth = Dimensions.get("screen").width;
const backgroundColor = "var(--game-background-color-la)";

const Index = (props) => {
  const imageOpacity = useRef(new Animated.Value(0)).current;
  const imageSize = Math.min(430, deviceWidth * 0.35);
  const { setPrePage, moduleObject } = props;
  const bodyText = useRef(new Animated.Value(-250)).current;
  const animation = useRef(
    new Animated.Value(-Dimensions.get("screen").width)
  ).current;

  useEffect(() => {
    Animated.parallel([
      Animated.timing(animation, {
        toValue: 0,
        duration: 1000,
        useNativeDriver: false,
      }),

      Animated.timing(bodyText, {
        toValue: 0,
        duration: 600,
        // delay: 100,
        useNativeDriver: false,
      }),
      Animated.timing(imageOpacity, {
        toValue: 1,
        duration: 800,
        useNativeDriver: false,
      }),
    ]).start();
  }, []);

  // const set1 = (props) => {
  //     return (
  //         <View style={{}}>
  //             <Text style={[styles.customText]}>
  //                 Okay, Now we're going to change things{`\n`}
  //                 around. Notice the difference?
  //             </Text>
  //             <TouchableOpacity onPress={() => {
  //                 props.setDisable(true);
  //                 props.fun()
  //             }} style={[styles.button, { marginLeft: undefined, alignSelf: 'center', marginTop: 22 }]}>
  //                 <Text style={[styles.buttonText]}>CONTINUE</Text>
  //             </TouchableOpacity>
  //         </View>
  //     )
  // }
  // const set2 = (props) => {
  //     return (
  //         <>

  //             <Text style={[styles.customText]}>
  //                 Great, Now what about when the odds{`\n`}
  //                 change?
  //             </Text>
  //             <TouchableOpacity onPress={() => {
  //                 props.setDisable(true);
  //                 props.fun()
  //             }} style={[styles.button, { marginLeft: undefined, alignSelf: 'center', marginTop: 22 }]}>
  //                 <Text style={[styles.buttonText]}>CONTINUE</Text>
  //             </TouchableOpacity>
  //         </>
  //     )
  // }
  // const set3 = (props) => {
  //     return (
  //         <>

  //             <Text style={[styles.customText]}>
  //                 Finally, We're going to change things{`\n`}
  //                 more.
  //             </Text>
  //             <TouchableOpacity onPress={() => {
  //                 props.setDisable(true);
  //                 props.fun()
  //             }} style={[styles.button, { marginLeft: undefined, alignSelf: 'center', marginTop: 22 }]}>
  //                 <Text style={[styles.buttonText]}>CONTINUE</Text>
  //             </TouchableOpacity>
  //         </>
  //     )
  // }

  const setMethod = () => {
    props.setDisable(true);
    props.fun();
  };

  useEffect(() => {
    if (props.currentSet !== 0) {
      setMethod();
    }
  }, [props.currentSet]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        position: "absolute",
        backgroundColor,
        flexDirection: "column",
      }}
    >
      {/* <Header currentRoute={"Understanding"} /> */}
      {
        props.currentSet === 0 ? (
          <Animated.View
            style={{
              width: deviceWidth > 600 ? "82%" : "90%",
              height: "75%",
              justifyContent: "center",
              // marginBottom: deviceWidth > 600 ? '13%' : '25%',
              transform: [{ translateX: animation }],
            }}
          >
            <Text
              style={{
                fontFamily: "var(--font-family-heading)",
                fontSize: Dimensions.get("screen").width > 600 ? 60 : 40,
                lineHeight: Dimensions.get("screen").width > 600 ? 68 : 48,
                fontWeight: "var(--font-weight-bold)",
                color: "#2f2f2f",
                marginBottom: hp("3%"),
              }}
            >
              {lossLabels.loss} & {lossLabels.gain}
            </Text>
            <Text
              style={{
                width:
                  Dimensions.get("screen").width > 1300
                    ? wp("60%")
                    : Dimensions.get("screen").width > 700
                      ? wp("60%")
                      : wp("89%"),
                Height: hp("24.3%"),
                fontSize: 19,
                textAlign: "Left",
                color: "#2f2f2f",
                marginBottom: hp("3%"),
                fontFamily: "Infra",
                lineHeight: 24,
                alignSelf: "flex-start",
              }}
            >
              {LOSSINTROBODY}
            </Text>
            <View
              style={{
                flexDirection: "row",
                marginBottom: hp("3%"),
                height: 18,
              }}
            >
              <img
                src={clockIcon}
                alt=""
                style={{ width: 18, height: 18, objectFit: "contain" }}
              />
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: "Infra",
                  color: "#2f2f2f",
                  paddingLeft: 10,
                }}
              >
                Typically 2-3 minutes
              </Text>
            </View>
            <ContinueButton onClick={() => props.fun()} text={buttonText} />
          </Animated.View>
        ) : null
        // (props.currentSet === 1 ? set1(props) : (props.currentSet === 2 ? set2(props) : (props.currentSet === 3 && set3(props))))
      }
      {props.currentSet === 0 && (
        <View style={{ height: "30%", width: "100%" }} />
      )}
      <Animated.Image
        source={require("../../../../../assets/images/mandg/mandg-active-square-la.png")}
        style={{
          position: "absolute",
          bottom: 0,
          right: 0,
          width: imageSize,
          height: imageSize,
          resizeMode: "contain",
          pointerEvents: "none",
          opacity: imageOpacity,
        }}
      />
    </div>
  );
};

export default withRouter(Index);
